// extracted by mini-css-extract-plugin
export default {"notification":"notification_notification__RtQ4e"};